import { IDynamicFormTheme } from '../types';

export const defaultFormTheme: IDynamicFormTheme = {
  headerBackcolor: '#1581D0',
  formBackcolor: '#F5F5F5',
  primaryColor: '#143971',
  primaryColorDark: 'rgba(17, 49, 98, 1)',
  primaryColorLight: 'rgba(20, 57, 113, 0.1)',
  textPrimary: '#1a1a1a',
  textSecondary: 'rgba(0, 0, 0, 0.5)',
  errorColor: 'rgba(230, 15, 65, 1)',
  successColor: 'rgba(25, 179, 148, 1)',
  fontFamily: 'Roboto, sans-serif',
};

export const mergeTheme = (
  customTheme?: Partial<IDynamicFormTheme>
): IDynamicFormTheme => {
  if (!customTheme) return defaultFormTheme;
  return { ...defaultFormTheme, ...customTheme };
};
